<template>
    <div class="material-list">
        <h4>{{ data.title }}</h4>
        <div class="row">
            <div class="col-md-6">
                <ul>
                    <li v-for="(document, i) in data.documents" :key="i">
                        
                        <a href="javascript:;" :id="`popover-target${i}`">
                            {{ document.name }}
                        </a>
                        <b-popover :target="`popover-target${i}`" triggers="focus" placement="right">
                            <div class="btn-group" role="group">
                                <a :href="`${$server_url+'storage/documents/'+document.link}`" type="button" target="_blank" class="btn yellow-btn">
                                    <span class="glyphicon glyphicon-eye-open"></span>
                                    View
                                </a>
                                <a  @click.prevent="downloadFile(document.link, document.name)"
                                    class="btn blue-btn">
                                    <span class="glyphicon glyphicon-cloud-download"></span>
                                    Download
                                </a>
                            </div>
                        </b-popover>
                    </li>
                </ul>
            </div>
        </div>
        <router-link :to="{name:'materials'}">View All Documents</router-link>
    </div>
</template>

<script>
import userAPI from '../../userApi';

export default {
    name: 'DocumentBox',
    props: {
        materialData: {
            type: Object,
            required: true
        }
    },
    data() {
        const host = window.location.hostname;
        const port = window.location.port;
        return {
            host,
            port,
            data: {}
        }
    },
    methods: {
        downloadFile(location, name) {
            try {
                userAPI.downloadPdf({ path: window.location.hostname == '202.141.226.195' ? '8069578_1703609074.pdf' : location }, res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', name + ".pdf");
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                });
            } catch (error) {
                console.error('Error downloading file:', error);
            }
        }
    },
    watch: {
        materialData: {
            immediate: true,
            handler(newData) {
                this.data = newData;
            }
        }
    }
}
</script>
